import { isEqual } from 'lodash';
import Image from 'next/image';

import { ProductImage } from '../../../interface/strapi';
import { SUBZERO_BRAND_NAME } from '../../../constants/brands';

/* eslint-disable-next-line */
type MainProductPageBannerProps = {
  brandBannerImage: { data: ProductImage };
  brandDescription?: string;
  brandTitle: string;
};

export function MainProductPageBanner(props: MainProductPageBannerProps) {
  const { brandBannerImage, brandDescription, brandTitle } = props;
  const backgroundColor = isEqual(brandTitle, SUBZERO_BRAND_NAME)
    ? ''
    : 'bg-black/50';

  return (
    <div className="w-full relative overflow-hidden">
      <div className="h-96 md:h-96 -mr-[1000px] md:mr-0 relative h-">
        <Image
          alt="Subzero Refrigeration Banner"
          blurDataURL="/icons/blur-placeholder.png"
          layout="fill"
          objectFit="cover"
          placeholder="blur"
          src={brandBannerImage?.data?.attributes?.url}
        />
      </div>

      <div
        className={`absolute top-0 bottom-0 right-0 left-0 text-white flex flex-col justify-center items-center lg:items-end px-6 md:px-36 ${backgroundColor} lg:bg-transparent`}
      >
        <div className="w-full lg:w-96 space-y-4">
          <p className="font-ChronicleDisplaySemibold text-header5 lg:text-header4 text-center uppercase leading-snug">
            {brandTitle}
          </p>
          <p className="text-caption lg:text-subtitle font-thin text-center leading-5 lg:leading-7">
            {brandDescription}
          </p>
        </div>
      </div>
    </div>
  );
}

export default MainProductPageBanner;
